// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"135817f4","425":"09744b03","566":"5beb31d5","968":"e9504773"}[chunkId] + ".chunk.js";
};